module.exports = __webpack_public_path__ + "img/iso_bizasafe.61009ec9.jpg";